var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaders = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.833 8.063c0-.242.194-.438.434-.438A2.16 2.16 0 0 1 12 8.5a2.16 2.16 0 0 1 1.733-.875c.24 0 .434.196.434.438a.435.435 0 0 1-.434.437c-.344 0-.675.138-.919.384-.244.247-.38.58-.38.928v3.063h1.3c.239 0 .433.196.433.438a.435.435 0 0 1-.434.437h-1.3v.438c0 .348.137.681.381.928.244.246.575.384.92.384.239 0 .433.196.433.438a.435.435 0 0 1-.434.437A2.16 2.16 0 0 1 12 15.5a2.17 2.17 0 0 1-1.733.875.435.435 0 0 1-.434-.438c0-.241.194-.437.434-.437.344 0 .675-.138.919-.384.244-.247.38-.58.38-.928v-.438h-1.3a.435.435 0 0 1-.433-.438c0-.241.194-.437.434-.437h1.3V9.812a1.32 1.32 0 0 0-.381-.928 1.3 1.3 0 0 0-.92-.384.435.435 0 0 1-.433-.438Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.5 6.313C5.5 5.588 6.082 5 6.8 5h10.4c.718 0 1.3.588 1.3 1.313v11.375c0 .724-.582 1.312-1.3 1.312H6.8c-.718 0-1.3-.588-1.3-1.313zm1.3-.438a.435.435 0 0 0-.433.438v11.375c0 .241.194.437.433.437h10.4c.24 0 .433-.196.433-.438V6.313a.435.435 0 0 0-.433-.437z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/headers.e5166b56.svg";